<template>
	<img v-if="isGroup()" :style="styleObject" :src="require('@/assets/group.png')" :onerror="onerror()" />
	<img v-else-if="this.avatar" :style="styleObject" :src="avatar" @error="onImgError" />
	<img v-else src="@/assets/default_avatar.jpg" :style="styleObject" />
</template>

<script>
import defaultAvatar from "@/assets/default_avatar.jpg";

export default {
	name: "ChatAvatar",

	props: {
		type: {
			type: String,
			default: "personal",
		},
		// 后端统一返回签名 URL；为空时显示默认头像
		avatar: {
			type: String,
			default: "",
		},
		size: {
			default: 30,
		},
		borderRadius: {
			type: String,
			default: "0px",
		},
	},

	created: function () {
		//
	},

	data() {
		return {
			styleObject: {
				width: this.size + "px",
				height: this.size + "px",
				borderRadius: this.borderRadius,
			},
		};
	},

	methods: {
		isGroup() {
			if (this.type === "group") {
				return true;
			} else {
				return false;
			}
		},
		onerror() {
			//
		},
		// 加载失败（如签名过期）时降级为默认头像
		onImgError(event) {
			event.target.src = defaultAvatar;
		},
	},
};
</script>

<style lang="less">
//
</style>
